import BaseInput from "./BaseInput"

interface LoginProps {
    title: string,
    placeholder: string,
    required?: boolean,
    id?: string,
    type?: React.HTMLInputTypeAttribute,
    autocomplete?: React.HTMLInputAutoCompleteAttribute,
    ref?: React.Ref<HTMLInputElement>
}

function LoginInput(
    {
        title,
        placeholder,
        type = "text",
        id = undefined,
        required = false,
        autocomplete = undefined,
        ref = undefined
    }: LoginProps
) {
    return <label>
        <span className='block mb-1'>{title}</span>
        <BaseInput
            id={id || title.toLowerCase()}
            placeholder={placeholder}
            type={type}
            required={required}
            autocomplete={autocomplete}
            ref={ref}
            className="w-full"
        />
    </label>
}

export default LoginInput